import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/operatorGroups'
import Component from 'components/OperatorGroups'

export default createListViewContainer({ actions, selectors: selectors.operatorGroups })(Component)
